<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Net Flow
              <router-link
                :to="{ name: 'NetFlowAdd' }"
                class="btn ml-auto"
                v-if="actionCreate && _.isEmpty(list.data)"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Net Flow</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <!-- <div class="btn-toolbar pull-right">
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div> -->

            <!-- <div class="card-tools">
              <button
                class="btn btn-outline"
                @click="exportFile()"
                v-if="1 == 0"
              >
                <i class="icon-download"></i> Export
              </button>
            </div> -->
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Audra Name -->
                  <div v-if="organizationId == 1" class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                      >Audra Name</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.accountId"
                          :options="Object.keys(pre.audraName)"
                          :custom-label="opt => pre.audraName[opt]"
                          placeholder="Select Audra Name"
                          :searchable="true"
                          :multiple="false"
                          id="accountId"
                          v-bind:class="{
                            'has-error': errors.has('accountId')
                          }"
                          name="accountId"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Interface -->

                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label">Interface</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.interface"
                          :options="Object.keys(pre.interfaceList)"
                          :custom-label="opt => pre.interfaceList[opt]"
                          placeholder="Select Interface"
                          :searchable="true"
                          :multiple="false"
                          id="interface"
                          name="interface"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row justify-content-end">
                    <div class="col-md-9">
                      <button type="submit" class="btn mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-outline"
                        @click="resetFilter()"
                      >
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th v-if="organizationId == 1">Audra Name</th>
                      <th>Interface</th>
                      <th>Timeout</th>
                      <th>Max Flow</th>
                      <th>Host</th>
                      <th>Port</th>
                      <th>Sampling Rate</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td v-if="organizationId == 1">
                        {{
                          pre.audraName[val.accountId]
                            ? pre.audraName[val.accountId]
                            : 'NA'
                        }}
                      </td>
                      <td>{{ val.interface }}</td>
                      <td>{{ val.timeout }}</td>
                      <td>{{ val.max_flow }}</td>
                      <td>{{ val.host }}</td>
                      <td>{{ val.port }}</td>
                      <td>{{ val.sampling_rate }}</td>
                      <td class="text-right">
                        <router-link
                          v-if="actionEdit == true || checkEditPermission(val)"
                          :to="{ name: 'NetFlowEdit', params: { id: val.id } }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <a
                          v-if="
                            actionDelete == true || checkDeletePermission(val)
                          "
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteObject(val.id, val.accountId, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import { CommonAPI, PermissionChecker } from '@/services/api'
import LocalStorage from '@/services/localStorage'
import axios from 'axios'
import { Notification } from 'element-ui'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { mapGetters } from 'vuex'
const fileDownload = require('js-file-download')

export default {
  name: 'NetFlow',
  metaInfo: {
    title: 'Net Flow | Dotlines'
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: true,
    actionView: false,
    actionEdit: true,
    actionDelete: true,
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: {
      audraName: []
    },
    is_loading: false,
    empty: false,
    empty_message: '',
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false
  }),
  mounted: function () {
    if (this.isMobile()) {
      window
        .$(document)
        .find('.push-menu-class')
        .trigger('click')
    }
    this.api_url = '/net_flows'
    this.initialize()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      this.reload()
    })
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    async initialize () {
      this.is_loading = true
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then(profile_info => {
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }

      // await CommonAPI.getCustomPermission(
      //   '/get-custom-permission-infos?path=api/net_flows'
      // ).then(response => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data
      //   }
      // })

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data['create_id_condition'],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   )
      //   this.actionCreate = true
      // }

      await this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
      await CommonAPI.getAudraName(LocalStorage.get('accountId'))
        .then(response => {
          this.pre.audraName = response
        })
        .catch(error => {
          console.log(error.response)
        })
      this.getInterface()
      this.is_loading = false
    },
    async getFilterData () {
      this.is_loading = true
      await this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
      this.is_loading = false
    },
    reload: function () {
      this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page }
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get('accountId'),
          ...this.$route.query,
          ...params
        }
        axios
          .get(this.api_url, {
            params: params
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          })
      })
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['edit_id_condition'],
          this.custom_permission_data['edit_refid_condition'],
          this.custom_permission_data['edit_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['delete_id_condition'],
          this.custom_permission_data['delete_refid_condition'],
          this.custom_permission_data['delete_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },
    async resetFilter () {
      this.list.current_page = 1
      this.filter = {}
      this.is_loading = true
      await this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true

          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
      this.is_loading = false
    },
    deleteObject: function (id, accountId, index) {
      const _this = this
      const delete_api_url = '/net_flows/' + id

      _this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
        .then(result => {
          if (result.isConfirmed) {
            _this.is_loading = true
            axios
              .delete(delete_api_url, {
                params: {
                  accountId: accountId
                }
              })
              .then(response => {
                _this.list.data.splice(index, 1)
                _this.$toaster.success(response.data.message)
                _this.is_loading = false
              })
              .catch(error => {
                _this.is_loading = false
                console.log(error)
                _this.$swal.fire('Failed!', 'failed to delete.', 'error')
              })
              .finally(() => {
                _this.is_loading = false
              })
          }
        })
    },
    exportFile: function () {
      this.is_loading = true
      axios
        .get('/net-flows-export', {
          params: { userAccountId: LocalStorage.get('accountId') },
          responseType: 'blob'
        })
        .then(response => {
          fileDownload(response.data, 'net_flows.xlsx')
        })
        .catch(error => {
          console.log('error ' + error)
        })
        .finally(() => {
          this.is_loading = false
          Notification.success({
            title: 'Export Completed',
            message: 'Export operation completed successfully',
            type: 'success'
          })
        })
    },
    getInterface: function () {
      axios
        .get('get-netflow-interface', {
          params: { accountId: LocalStorage.get('accountId') }
        })
        .then(response => {
          this.pre.interfaceList = response.data
        })
        .catch(error => {
          console.log('error ' + error)
        })
        .finally(() => {})
    }
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
